import { useSelector } from 'react-redux';
import { getCartItems, getCartSum } from '../../../cart/cart-reducer';
import { useProject } from '../../project-hooks/useProject';
import { ContentTitle, Subtitle } from '../../../components/typography/Heading';
import { CartItem } from './CartItem';
import { formatKrMoney } from '../../../utils';
import PaymentMethods from '../payment-methods/PaymentMethods';
import { canChoosePaymentMethod } from '../../../payment/payment-form-config';
import { useMemo, useState } from 'react';
import { ExtraAmountCartItem } from './ExtraAmountCartItem';
import { NameAndCommentContainer } from '../name-and-comment/NameAndCommentContainer';
import { mapCartItemForPayment } from './cart-model';
import styles from './cart.module.less';

export const Cart = () => {
    const project = useProject();

    const minAmount = useSelector((state) => state.paymentConfig.giveMinAmount);
    const maxAmount = useSelector((state) => state.paymentConfig.giveMaxAmount);
    const cartSum = useSelector((state) => getCartSum(state, project.id));
    const cartItems = useSelector((state) => getCartItems(state, project.id)) || [];

    const expandedNameAndComment = project?.profile?.expandedNameAndComment;
    const hideSupportButton = project?.profile?.hideSupportButton;

    const [giverName, setGiverName] = useState('');
    const [comment, setComment] = useState('');

    const [extraAmount, setExtraAmount] = useState(0);

    const rewards = cartItems.map((item) => mapCartItemForPayment(item, project));

    const canChoosePaymentMethodFromState = canChoosePaymentMethod({
        amount: cartSum,
        giveMinAmount: project?.profile?.giveMinAmount || minAmount,
        giveMaxAmount: maxAmount,
        rewards,
    });

    const totalSum = useMemo(() => cartSum + (extraAmount || 0), [cartSum, extraAmount]);

    const addAmount = (amount) => {
        setExtraAmount(amount);
    };

    return (
        <div className={styles.container}>
            <ContentTitle tag={'h2'}>Kasse</ContentTitle>
            <Subtitle>Produkter</Subtitle>
            <div className={styles.products}>
                {cartItems.map((item) => (
                    <CartItem key={item.rewardId} item={item} reward={item.reward} />
                ))}
                {!hideSupportButton && <ExtraAmountCartItem updateExtraAmount={addAmount} />}
            </div>
            <div className={styles.cartSum}>
                <div>
                    <p className={styles.cartSumItem}>Totalsum</p>
                    <span className={styles.cartSumMva}>inkl. mva og frakt</span>
                </div>
                <span className={styles.cartSumItem}>{formatKrMoney(totalSum)}</span>
            </div>
            <NameAndCommentContainer
                giverName={giverName}
                setGiverName={(giverName) => setGiverName(giverName)}
                comment={comment}
                setComment={(c) => setComment(c)}
                className={styles.commentContainer}
                isOpen={expandedNameAndComment}
            />
            <PaymentMethods
                amount={totalSum}
                rewards={rewards}
                disabled={!canChoosePaymentMethodFromState}
                isCart={true}
                comment={comment}
                giverName={giverName}
            />
        </div>
    );
};
